import React from "react";
import { GetPricesOfCurrency } from "./Hit";
import { translate } from "../../../Services/translation";
import { HitProps, RelatedHitProps } from "./types/HitProps";
import { GetProductGtm } from "../utils/ProductGtm";
import { HitImages, HitUrl } from "../utils/HitUtils";

function UnsafeRelatedItem({ hit }: HitProps) {
  const priceGroup = GetPricesOfCurrency(hit.price);
  const formattedCampaignPrice = priceGroup.formattedCampaignPrice;
  const formattedPrice = priceGroup.formattedPrice;
  const url = HitUrl(hit);
  const imageUrls = HitImages(hit);
  const gtmProduct = GetProductGtm(
    hit,
    priceGroup.actualPrice,
    priceGroup.discount
  );

  return (
    <div className="related-products__product product-slider-card small-6 medium-3">
      <json-data className="gtm-product">
        {JSON.stringify(gtmProduct)}
      </json-data>
      <a href={url}>
        <figure>
          {imageUrls.length > 0 ? (
            imageUrls.map((img, i) => (
              <img
                key={img + i}
                src={img}
                alt={hit.name}
                className={i == 0 ? "first" : "second"}
                loading="lazy"
              />
            ))
          ) : (
            <span>{translate("product.missing-image")}</span>
          )}
        </figure>
        <article>
          <div className="product-slider-card__header">
            <div>
              <span className="product-slider-card__brand">{hit.brand}</span>
              <span className="product-slider-card__name">
                {hit.styleName || hit.name}
              </span>
            </div>
          </div>
          <div className="product-slider-card__price">
            {formattedCampaignPrice ? (
              <span>{formattedCampaignPrice}</span>
            ) : formattedPrice ? (
              <span>{formattedPrice}</span>
            ) : null}
          </div>
          <meta content={hit.description} />
        </article>
      </a>
    </div>
  );
}

const RelatedItem = ({ item }: RelatedHitProps) => {
  try {
    return UnsafeRelatedItem({ hit: item });
  } catch (error) {
    console.warn(error);
    return <></>;
  }
};

export default RelatedItem;
